import { Button, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 800px;

  @media (max-width: 1024px) {
    width: 100vw;
  }
`;

const ContentArea = styled.div`
  display: flex;
  flex-direction: row;
  width: 1140px;
  height: 100%;
  position: relative;
  align-self: center;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const HeaderText = styled.div`
  height: 180px;
  width: 937px;
  left: -62px;
  top: 123px;
  position: absolute;
  font-family: CeraStencil;
  font-size: 120px;
  font-weight: 700;
  line-height: 90px;
  text-indent: 70px;

  @media (max-width: 1024px) {
    font-size: 40px;
    line-height: 33px;
    left: 13px;
    text-indent: 0;
    width: 288px;
  }
`;
const CountdownWrapper = styled.div`
  height: 281px;
  width: 730px;
  position: absolute;
  right: -78px;
  top: 283px;
  border-radius: 0px;
  background-color: ${theme.SECONDARY};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .colons {
    font-family: CeraPro;
    font-size: 72px;
    font-weight: 500;
    line-height: 91px;
    margin: -38px 7px 0;
  }

  .timeUnit,
  .dayUnit {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;

    .time {
      font-family: CeraPro;
      font-size: 72px;
      font-weight: 500;
      line-height: 91px;
    }
    .label {
      font-size: 24px;
      font-weight: 500;
      line-height: 30px;
    }
  }

  .dayUnit {
    color: #fff;
  }

  @media (max-width: 1024px) {
    height: 106px;
    width: 278px;
    right: 0;
    top: 215px;

    .colons {
      font-size: 32px;
      line-height: 41px;
      margin: -18px 7px 0;
    }

    .timeUnit,
    .dayUnit {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100px;

      .time {
        font-size: 32px;
        line-height: 40px;
      }
      .label {
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
      }
    }
  }
`;

const RegisterButtonWrapper = styled.div`
  position: absolute;
  top: 390px;
  left: -52px;

  button {
    width: 268px !important;

    p {
      font-size: 22px;
      font-weight: 500;
      line-height: 28px;
    }
  }

  @media (max-width: 1024px) {
    width: 100vw;
    left: 0;
    top: 360px;

    button {
      margin: 0 auto;
      width: 288px !important;

      p {
        font-family: CeraPro;
        font-size: 18px;
        line-height: 22px;
      }
    }
  }
`;

const EventCountdown = ({}) => {
  const { t } = useTranslation();
  const eventDate = new Date(2022, 3, 29); // PLACEHOLDER

  const [countDown, setCountDown] = useState(eventDate.getTime() - new Date().getTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(eventDate.getTime() - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Wrapper>
      <ContentArea>
        <HeaderText>{t('website.registrationEnds')}</HeaderText>

        <CountdownWrapper>
          <div className="dayUnit">
            <div className="time">
              {('00' + Math.floor(countDown / (1000 * 60 * 60 * 24))).slice(-2)}
            </div>

            <div className="label">{t('website.days')}</div>
          </div>

          <Text className="colons" col="white">
            :
          </Text>

          <div className="timeUnit">
            <div className="time">
              {('00' + Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(
                -2
              )}
            </div>

            <div className="label">{t('website.hours')}</div>
          </div>

          <Text className="colons">:</Text>

          <div className="timeUnit">
            <div className="time">
              {('00' + Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60))).slice(-2)}
            </div>

            <div className="label">{t('website.minutes')}</div>
          </div>

          <Text className="colons">:</Text>

          <div className="timeUnit">
            <div className="time">
              {('00' + Math.floor((countDown % (1000 * 60)) / 1000)).slice(-2)}
            </div>

            <div className="label">{t('website.seconds')}</div>
          </div>
        </CountdownWrapper>

        <RegisterButtonWrapper>
          <Button text={t('website.registerForCombine')} website />
        </RegisterButtonWrapper>
      </ContentArea>
    </Wrapper>
  );
};

export default EventCountdown;
